// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1OX34","title":"Header_title__3A6AU","left":"Header_left__guLn4","clinicName":"Header_clinicName__1L7oY"};